<!--
 * @Author: ldx
 * @Date: 2022-05-10 10:40:23
 * @LastEditors: ldx
 * @LastEditTime: 2022-05-10 17:20:42
 * @Description: 
-->
<template>
  <div class="agreement-container">
    <h2>安道用户协议</h2>
    <div class="text" style="margin-bottom: 2em">欢迎使用安道产品及服务！</div>
    <div class="text bold" style="margin-bottom: 1em">特别提示：</div>
    <div class="text bold">
      深圳安道云科股份有限公司（以下简称“安道”）在此提醒您（用户）在注册成为用户之前，请认真阅读本《安道用户协议》（以下简称“协议”），本协议的效力范围及于安道及关联公司的一切产品和服务（以下简称“服务”），您在享受任何单项服务时，应当受本协议的约束。您应充分理解本协议中各条款，对于免除或者限制责任的条款可能将以加粗字体显示，您应重点阅读。如果你未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。如果您不同意本协议条款的任意内容，或者无法准确理解协议的相关解释和说明，请不要进行后续操作。
    </div>
    <div class="text">
      您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。本协议可由安道随时更新，更新后的协议条款一旦公布即代替原来的协议条款，安道将不再另行通知。用户可在各服务系统查阅最新版协议条款。本协议条款变更后，如果用户继续使用安道服务，即视为用户已接受修改后的协议。届时您不应以未阅读、不理解、不认可本协议条款的内容或者未获得我公司对您问询解答等理由，主张本协议或其部分条款无效，或要求撤销本协议的全部或部分条款。
    </div>
    <h3>一、服务内容</h3>
    <div class="text">
      安道及关联公司提供的单项服务包括但不限于
      <span class="focus">安道助手、安道综合服务后台、安道云班牌</span>
      等，亦包括
      <span class="focus"> 安道及关联公司的各种虚拟产品和增值服务</span>
      （如主题、电子书等），服务的具体内容以各服务系统说明为准。
    </div>
    <h3>二、账号注册及使用规则</h3>
    <div class="text section_1em">
      1、安道帐号系用于识别您身份的标识，帐号的所有权属于安道，您作为初始申请注册人仅拥有您所注册帐号的使用权。
    </div>
    <div class="text section_1em">
      2、您确认，在您开始注册程序使用安道服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
    </div>
    <div class="text section_1em">
      3、您应提供及时、详尽及准确的资料，并不断更新注册资料，符合及时、详尽、准确的要求。您保证在注册时所提交的所有资料（包括但不限于手机号码、邮箱等）真实、准确、合法、有效且系您本人的资料。如果因注册信息不真实或更新不及时而引发的相关问题，
      安道不负任何责任。您可以通过安道帐号设置页面查询、更正您的信息，您应当通过真实身份信息认证注册帐号，且您提交的帐号名称、头像和简介等注册信息中不得出现违法和不良信息，经安道审核，如存在上述情况，安道将不予注册；同时，在注册后，如发现您以虚假信息骗取帐号名称注册，或您的帐号头像、简介等注册信息存在违法和不良信息的，安道有权不经通知单方采取限期改正、暂停使用、终止帐号等措施。当您按照注册页面提示填写信息、阅读并同意本协议条款且完成全部注册程序后，您可获得安道帐号并成为安道用户。
    </div>
    <div class="text section_1em">
      4、由于您的安道帐号关联您的个人信息及安道商业信息，您的安道帐号仅限您本人使用，不得赠与、借用、租用、有偿或无偿转让或售卖安道帐号或者以其他方式许可非初始申请注册人使用安道帐号，安道有权对上述行为进行独立判断并处理，您应当自行承担由此产生的任何责任，同时安道保留追究上述行为人法律责任的权利。且由此产生的一切责任均由您承担。
    </div>
    <div class="text section_1em">
      5、为了防止资源占用，如您连续24个月未使用您的安道帐号或未通过安道认可的其他方式登录过您的帐号，安道有权对该帐号进行注销，您将不能再通过该帐号登录或使用相关服务。如该帐号有关联的待处理交易或余额等，安道会在合理范围内协助您处理，请您按照安道提示的方式进行操作。
    </div>
    <h3>三、账户隐私与安全</h3>
    <div class="text section_1em">
      1、安道应当以高度的勤勉、审慎义务对待用户提供的各项数据信息。对于授权接收的用户信息，除本协议明确阐述和相关法律规定外，安道公司不会向任何无关的第三方提供、泄漏或交易用户的个人信息。
    </div>
    <div class="text">
      2、依法豁免征得同意收集和使用的个人信息
      请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：
    </div>
    <div class="text">（1）与国家安全、国防安全直接相关的</div>
    <div class="text">
      （2）与公共安全、公共卫生、重大公共利益直接相关的，例如疫情防范；
    </div>
    <div class="text">（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>
    <div class="text">
      （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
    </div>
    <div class="text">（5）所收集的您的个人信息是您自行向社会公众公开的</div>
    <div class="text">
      （6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
    </div>
    <div class="text">（7）根据您的要求签订或履行合同所必需的；</div>
    <div class="text">
      （8）用于维护软件及相关服务的安全稳定运行所必需的，例如发现、处置软件及相关服务的故障；
    </div>
    <div class="text">（9）为合法的新闻报道所必需的；</div>
    <div class="text">
      （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
    </div>
    <div class="text section_1em">（11）法律法规规定的其他情形。</div>
    <div class="text section_1em">
      3、您的帐号为您自行设置并由您保管，安道任何时候均不会主动要求您提供您的帐号密码。建议您采取特定措施保护您的帐号安全，包括但不限于安装防病毒木马软件、定期更改密码等措施。安道帐号因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，安道并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。
    </div>
    <div class="text section_1em">
      4、安道公司有权基于您的行为及应适用的规则判断，在认为可能不利于安道公司提供服务或涉及违法违规情形时，可不经通知而先行暂停、中断或终止向您提供本协议项下的全部或部分服务，且无需因此对您或任何第三方承担任何责任。
    </div>
    <div class="text">前述情况包括但不限于：</div>
    <div class="text">
      （1）安道公司认为您不是注册登录的信息主体本人或合法授权人员时；
    </div>
    <div class="text">
      （2）安道公司发现异常情况或有合理理由怀疑操作有风险或有违法之虞时；
    </div>
    <div class="text">
      （3）安道公司认为账户存在未经授权的使用或安道公司认为有风险之其他情形；
    </div>
    <div class="text">
      （4）安道公司认为您已经违反本协议中规定的各类规则、规范、指引或用户协议；
    </div>
    <div class="text">
      （5）安道公司基于上述原因之外，根据您的行为及应使用的规则判断需先行暂停、中断或终止向您提供本协议项下的全部或部分用户服务。
    </div>
    <h3>四、服务使用规范</h3>
    <div class="text section_1em">
      1、您充分了解并同意，安道仅为用户提供服务平台，您应自行对利用服务从事的所有行为及结果承担责任（包括但不限于在线签署各类单项条款、发布信息、购买商品及服务及披露信息等）。相应地，您应了解，使用安道服务可能发生来自他人非法或不当行为（或信息）的风险，您应自行判断及行动，并自行承担相应的风险。
    </div>
    <div class="text bold section_1em">
      2、您应自行承担因使用服务所产生的费用，包括但不限于上网流量费、通信服务费等。
    </div>
    <div class="text section_1em">
      3、除非另有说明，本协议项下的服务只能用于非商业用途。您承诺不对安道服务任何部分或服务之使用或获得，进行复制、拷贝、出售、转售或用于包括但不限于广告及任何其它商业目的。
    </div>
    <div class="text">
      4、您承诺不会利用安道服务进行任何违法或不当的活动，包括但不限于下列行为:
    </div>
    <div class="text">4.1上载、传送或分享含有下列内容之一的信息</div>
    <div class="text">(a)反对宪法所确定的基本原则的；</div>
    <div class="text">
      (b)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
    </div>
    <div class="text">(c)损害国家荣誉和利益的；</div>
    <div class="text">(d)煽动民族仇恨、民族歧视、破坏民族团结的；</div>
    <div class="text">(e)破坏国家宗教政策，宣扬邪教和封建迷信的；</div>
    <div class="text">(f)散布谣言，扰乱社会秩序，破坏社会稳定的；</div>
    <div class="text">
      (g)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
    </div>
    <div class="text">(h)侮辱或者诽谤他人，侵害他人合法权利的；</div>
    <div class="text">
      (i)含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；
    </div>
    <div class="text section_1em">
      (j)含有中国或其您所在国国家管辖法所适用的法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；
    </div>
    <div class="text">
      4.2冒充任何人或机构，或以虚伪不实的方式陈述或谎称与任何人或机构有关；
    </div>
    <div class="text section_1em">
      4.3伪造标题或以其他方式操控识别资料，使人误认为该内容为安道公司或其关联公司所传送；
    </div>
    <div class="text section_1em">
      4.4将依据任何法律或合约或法定关系（例如由于雇佣关系和依据保密合约所得知或揭露之内部资料、专属及机密资料）知悉但无权传送之任何内容加以上载、传送或分享；
    </div>
    <div class="text section_1em">
      4.5将涉嫌侵害他人权利（包括但不限于著作权、专利权、商标权、商业秘密等知识产权）之内容上载、传送或分享；
    </div>
    <div class="text section_1em">
      4.6跟踪或以其它方式骚扰他人,或通过安道服务向好友或其他用户发送大量信息；
    </div>
    <div class="text section_1em">
      4.7将任何广告、推广信息、促销资料、“垃圾邮件”、“滥发信件”、“连锁信件”、“直销”或其它任何形式的劝诱资料加以上载、传送或分享；供前述目的使用的专用区域或专用功能除外；
    </div>
    <div class="text section_1em">
      4.8因安道服务并非为某些特定目的而设计，您不可将服务用于包括但不限于核设施、军事用途、医疗设施、交通通讯等重要领域。如果因为软件或服务的原因导致上述操作失败而带来的人员伤亡、财产损失和环境破坏等，安道公司不承担法律责任；
    </div>
    <div class="text section_1em">
      4.9进行任何超出正常的好友或用户之间内部或外部信息沟通、交流等目的的行为；
    </div>
    <div class="text section_1em">
      4.10出于超出正常好友或用户之间内部或外部信息沟通、交流等目的（包括但不限于为发送广告、垃圾、骚扰或违法违规等信息的目的），通过自己添加或诱导他人添加等任何方式使自己与其他用户形成好友关系（好友关系包括但不限于单向好友关系和双向好友关系，下同）；
    </div>
    <div class="text section_1em">
      4.11违反遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的行为；
    </div>
    <div class="text section_1em">
      4.12从事任何违反中国法律、法规、规章、政策及规范性文件的行为。
    </div>
    <div class="text">5、您承诺不对安道软件和服务从事以下行为：</div>
    <div class="text">
      5.1将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，加以上载、张贴、发送电子邮件或以其他方式传送；
    </div>
    <div class="text">
      5.2干扰或破坏本服务或与本服务相连线之服务器和网络，或违反任何关于本服务连线网络之规定、程序、政策或规范；
    </div>
    <div class="text">
      5.3通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
    </div>
    <div class="text">
      5.4通过非安道公司开发、授权的第三方软件、插件、外挂、系统，登录或使用软件及服务，或制作、发布、传播上述工具；
    </div>
    <div class="text section_1em">
      5.5自行、授权他人或利用第三方软件对本软件及其组件、模块、数据等进行干扰。
    </div>
    <div class="text section_1em">
      6、您同意并接受安道有权对您使用服务的情况进行审查、监督并采取相应行动，包括但不限于删除信息、中止或终止服务，及向有关机关报告。
    </div>
    <div class="text section_1em">
      7、您承诺不以任何形式使用安道服务侵犯安道公司的商业利益，或从事任何可能对安道造成损害或不利于安道的行为。
    </div>
    <div class="text section_1em">
      8、您了解并同意，在您使用安道服务过程中，安道公司及其关联公司自行或由其他第三方合作伙伴向您发送广告、推广或宣传信息（包括商业或非商业信息）的，安道公司将依照法律的规定对广告商履行相关义务（包括向您提供选择关闭广告信息的功能），
      <span class="bold">
        您应当自行判断广告信息的真实性可可靠性并为自己的判断行为负责；除法律明确规定外，您因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，安道公司不承担责任。
      </span>
    </div>
    <div class="text section_1em">
      9、如您作为企业组织用户申请管理员账号或子管理员账号，则应自行添加、指定或变更管理成员和/或子管理员，并对管理成员的行为自行承担责任；安道根据您管理员/子管理员账号的行为对所在企业组织成员服务的调整亦由您承担后果，因此给安道公司或他人造成损失的，您应当予以赔偿
    </div>
    <div class="text bold section_1em">
      10、如您在安道客户端使用支付宝向您通过的红包功能或收付、转账功能的，应当依照法律、法规等规范性文件的规定开展，不得以非法方式使用红包功能或收付、转账功能，也不得将红包功能或支付、转账功能用于实施非法活动，例如实施赌博、非法吸收公众存款、集资诈骗、开展传销等违法犯罪行为，或为违法犯罪行为提供协助。因此给安道公司或他人造成损失的，您应当予以赔偿。
    </div>
    <div class="text section_1em">
      11、您充分了解并同意，您必须为自己注册帐号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对使用本服务时接触到的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。安道公司无法且不会对您因前述风险而导致的任何损失或损害承担责任。
    </div>
    <div class="text section_1em">
      12、如果安道公司发现或收到他人举报您有违反本协议约定的，安道公司有权依照相关法律法规的规定对相关举报内容核实、转通知以及删除、屏蔽等措施，以及采取包括但不限于收回账号，限制、暂停、终止您使用部分或全部本服务，追究法律责任等措施。
    </div>
    <h3>五、法律责任与免责条款</h3>
    <div class="text">
      1、用户同意并理解安道公司将会尽其商业上的合理努力保障您在安道服务中的数据存储安全，但是安道公司并不能就此提供完全保证，包括但不限于以下情形：
    </div>
    <div class="text">
      （1）安道公司不对用户在安道服务中相关数据的删除或储存失败负责；
    </div>
    <div class="text section_1em">
      （2）安道公司有权按照适用的数据保护法律的要求并根据实际情况决定用户在安道云应用中数据的最长储存期限，并在服务器上为其分配数据目前技术环境下安道公司就安道软件本身运行所能承受的最大存储空间等。用户可根据自己的需要在该存储空间范围内自行备份相关数据。但因存储空间受限或技术原因、设备及网络环境等因素影响，该存储空间的数据可能存储无法全部保存、遗失或错漏等情形，安道公司对此不承担责任。
    </div>
    <div class="text section_1em">
      （3）如果你停止使用安道软件相关功能和服务或服务被终止、取消，安道公司保证从服务器上永久地删除你的数据。且在服务停止、终止或取消后，安道公司没有义务向你返还任何数据。
    </div>
    <div class="text section_1em">
      2、基于安道公司无法确保数据源所载数据的准确性、数据接收通道是否持续通畅，因此无法保证相关服务提供的持续性、及时性、准确性。如果您发现经安道公司接收、更新的数据存在不准确或者错误、遗漏等情况，应及时联系安道公司或者您信息所在的数据源进行核实。
    </div>
    <div class="text bold">
      3、因下列原因导致安道公司无法正常提供服务的，安道公司不承担责任。
    </div>
    <div class="text bold">（1）安道公司承载服务系统停机维护期间；</div>
    <div class="text bold">
      （2）您的电脑、手机软硬件和通信线路、供电线路出现故障的；
    </div>
    <div class="text bold">
      （3）您操作不当或通过非安道公司授权或认可的方式使用服务的；
    </div>
    <div class="text bold">
      （4）因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障或政府行为等原因；
    </div>
    <div class="text bold">
      （5）由于黑客攻击、网络供应商技术调整或故障、网站升级、系统方面的问题等原因而造成的服务中断或延迟；
    </div>
    <div class="text bold">
      （6）因不可抗力，造成软件服务系统障碍不能执行业务的。
    </div>
    <div class="text section_1em">
      尽管有前款约定，安道公司将采取合理行动积极促使服务恢复正常
    </div>
    <div class="text section_1em">
      4. 安道软件不含有任何旨在破坏您计算机数据和获取您隐私信息的恶意代码。安道软件经过详细的测试，但不能保证与所有的软硬件系统完全兼容，不能保证本软件完全没有错误。如果出现不兼容及软件错误的情况，您可通过本协议下方的联系方式将情况报告给安道公司。如果无法解决兼容性问题，您可以删除本软件。<span
        class="bole"
        >由此给您造成损失的，您同意安道公司不承担任何责任。</span
      >
    </div>
    <div class="text section_1em">
      5. 您知悉并同意，为实现部分软件功能，安道有权将您在使用软件过程当中产生的部分或全部数据信息，上传、保存至第三方云服务存储器，并根据您发出的功能指令需求，自行调取相关数据信息。因第三方云服务发生中断等功能障碍事故导致安道公司无法正常提供软件服务的，安道公司会尽其商业上的合理努力负责协调解决，但由此给您造成损失的，您同意安道公司不承担任何责任。
    </div>
    <div class="text bold section_1em">
      6.在任何情况下，安道都不对您或任何第三方因本协议产生的任何间接性、后果性、惩戒性的、偶然的、特殊或惩罚性的损害赔偿承担责任。
    </div>
    <h3>六、知识产权</h3>
    <div class="text section_1em">
      1.
      您在安道发布的信息不得侵犯任何第三人的知识产权，未经具有相关所有权人之事先书面同意，您不得以任何方式上传、发布、修改、传播或复制任何受著作权保护的材料、商标或属于其他人的专有信息。如果收到任何著作权人或其合法代表发给安道的适当通知后，我们将在审查的基础上移除该等侵犯他人著作权的内容。
    </div>
    <div class="text">
      2.
      您在使用安道服务时利用安道帐号发表上传的文字、图片、视频、软件以及表演等原创信息的知识产权归您所有，但是您确认您对该等信息的发表、上传行为视同为对安道非独占地、永久地、不可撤销地授予该等信息相关全部知识产权的使用、复制等权利，并且您同意安道可转授权上述权利。
    </div>
    <h3>七、服务条款修改</h3>
    <div class="text">
      1.安道有权随时修改本协议条款的任何内容，一旦本协议条款的任何内容发生变动，安道公司将会在软件内向用户提示修改内容；
    </div>
    <div class="text">
      2.如果不同意安道对本协议条款所做的修改，用户有权停止使用功能和服务。
    </div>
    <div class="text">
      3.如果用户继续使用软件，则视为用户接受安道公司对本协议条款所做的修改。
    </div>
    <h3>八、争议解决及其他</h3>
    <div class="text">
      1、本协的订立、执行、解释及争议的解决均适用中华人民共和国法律（不包括香港特别行政区、澳门特别行政区和台湾地区的法律）。您与我们因本协议而产生的任何纠纷，双方应本着友好的态度协商解决，任何一方有权将争议提交至安道注册经营地人民法院诉讼解决。
    </div>
    <div class="text">
      2、如本协议的任何条款被视作无效或无法执行，则上述条款可被分离，其余部份则仍具有法律效力。
    </div>
    <div class="text">
      3、安道公司于用户过失或违约时放弃本协议规定的权利的，不得视为其对用户的其他或以后同类之过失或违约行为弃权。
    </div>
    <div class="text">
      4、本协议应取代双方此前就本协议任何事项达成的全部口头和书面协议、安排、谅解和通信。
    </div>
    <div class="text">
      5、您理解并同意，安道公司有权自主决定经营策略并根据业务调整情况将本协议项下的全部权利义务一并转移给其关联公司，转让将以本协议规定的方式通知，用户承诺对此不持有异议。
    </div>
    <h3>九、联系方式</h3>
    <div class="text">
      至此，您已经详细阅读并已理解本协议，并同意严格遵守全部条款之约定。如果您对本协议有任何疑问或者希望从安道公司获得任何信息，请按下列联系方式与我们联系。
    </div>
    <div class="text">邮箱：amdox2020@126.com</div>
    <div class="text">电 话：400-632-8880</div>
  </div>
</template>

<script>
export default {
  name: "Agreement",
  created() {
    window.document.title = "安道协议";
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.agreement-container {
  padding: 15px 25px;
  font-size: 14px;
  text-align: justify;
  max-width: 800px;
  margin: 0 auto;
  color: #222222;
  h2 {
    font-size: 16px;
    text-align: center;
  }
  h3 {
    font-size: 14px;
    margin-top: 3em;
  }
  .text {
    line-height: 26px;
  }
  .bold {
    font-weight: 700;
  }
  .focus {
    color: red;
  }
  .section_1em {
    margin-bottom: 1em;
  }
}
</style>
